module.exports = __webpack_public_path__ + "static/img/index_item03.bfb955e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_item03.png
// module id = qc3A
// module chunks = 0